import { useEffect, useState } from 'react';

export function usePrefersReducedMotion() {
	const [reduced, setReduced] = useState(false);

	useEffect(() => {
		const mq = window.matchMedia?.('(prefers-reduced-motion: reduce)');
		if (!mq) return;

		const onChange = () => setReduced(mq.matches);
		setReduced(mq.matches);

		// Safari compatibility
		if (mq.addEventListener) mq.addEventListener('change', onChange);
		else mq.addListener(onChange);

		return () => {
			if (mq.removeEventListener) mq.removeEventListener('change', onChange);
			else mq.removeListener(onChange);
		};
	}, []);

	return reduced;
}
